module.exports = __webpack_public_path__ + "static/media/checkitoff-macbook-center-dashboard.e9a3da82.png";